module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_0.c4a9a217.png";